import * as React from 'react';
import { SVGProps } from 'react';

const IconWellConstructionSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2H7v12h2v8h2V12H9V2Zm8 0h-2v10h-2v10h2v-8h2V2Z"
      fill="var(--color-typo-primary)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2H3v1.882c0 .735.171 1.46.5 2.118l.053.106a4.236 4.236 0 0 1 0 3.788l-.106.212a4.236 4.236 0 0 0 0 3.788l.106.212a4.236 4.236 0 0 1 0 3.788L3.5 18a4.736 4.736 0 0 0-.5 2.118V22h5v-7H6V2Zm12 0h3v1.882c0 .735-.171 1.46-.5 2.118l-.053.106a4.236 4.236 0 0 0 0 3.788l.106.212a4.236 4.236 0 0 1 0 3.788l-.106.212a4.236 4.236 0 0 0 0 3.788L20.5 18c.329.658.5 1.383.5 2.118V22h-5v-7h2V2Z"
      fill="var(--color-typo-secondary)"
    />
  </svg>
);
export default IconWellConstructionSizeM;
